// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"94e19732","80":"09e2fecc","192":"67cc2ab2","385":"b747a636","479":"12cd0e90","591":"a528fc48","642":"69f8a8a6","655":"1e7237d2","671":"159ec8c9","895":"b8b9365a"}[chunkId] + ".chunk.js";
};